import { ContactModalContent } from 'components/contact/contactNotificationModal/ContactModalContent'
import { useActualContact } from 'components/contact/contactUtils'
import { BlockSpinner } from 'components/spinner/Spinner'
import { useTranslation } from 'next-i18next'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'
import { ApiTrustedContactResponse, ApiType } from 'utils/types'

type NotificationContact = ApiTrustedContactResponse | ApiType['TrustedContactUserResponse']
type NotificationContactKind = 'trusted-contact' | 'trusted-contact-user'

type ContactBoundModalProps = {
  contact?: NotificationContact
  contactKind?: NotificationContactKind
  type?: ApiType['TrustedContactUserResponse']['type']
}

//
// This modal is used for:
// - notifying the invite orignator that the invite has been accepted
// - telling a new user that they have just accepted the TC invite
//

export const ContactBoundModal = (props: ContactBoundModalProps) => {
  const { isLoading } = useDynamicTranslations('dashboard')
  const { t } = useTranslation('dashboard')
  const isTrustedContact = props.contactKind !== 'trusted-contact-user'
  const { actualContact: trustedContact, isUserLoading } = useActualContact(
    isTrustedContact ? (props.contact as ApiType['TrustedContactResponse'] | undefined) : undefined
  )
  const actualContact =
    trustedContact ??
    (!isTrustedContact
      ? (props.contact as ApiType['TrustedContactUserResponse'] | undefined)
      : undefined)

  const contactName = actualContact?.first_name || actualContact?.email

  if (isLoading || (isTrustedContact && isUserLoading)) {
    return <BlockSpinner />
  }
  return (
    <ContactModalContent
      actualContact={actualContact}
      contactType={props.type}
      titleText={t('dashboard.contact_bound_modal_title', { who: contactName })}
      descriptionText={<>{t('dashboard.contact_bound_modal_desc')}</>}
    />
  )
}
